import dayjs from 'dayjs';

export function isDatePassed(time: string) {
  return dayjs(time) > dayjs()
}